
/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

Mindbreeze.define('service/ajax_channel',["jquery", "underscore", "backbone", "service/channel"], function($, _, Backbone, Channel) {


  // reads from the input and triggers the following events on the output
  // 
  var AjaxChannel = Channel.extend({
    
    internalCall: function(path, request, responseObserver, formatOptions, headers, options) {
      var that = this,
          promise = new Channel.DeferredCallFinished(this);

      var dataType = formatOptions && formatOptions.dataType || 'json';
      
      $.ajax({
        url: this.get("url") + (path || ""),
        type: options && options.method || "post",
        crossDomain: options && options.crossDomain || true,
        xhrFields: options && options.xhrFields || { 
          withCredentials: true 
        },
        headers: options && options.headers || {},
        dataType: dataType,
        data: request ? (/json/i.test(dataType) ? JSON.stringify(request) : request) : null,
        context: this
      }).done(function(data) { // success
        that.success(data, promise, responseObserver);
      }).fail(function(jqXHR, textStatus, errorThrown) { // failure
        var err = {status: jqXHR.statusCode(), message: textStatus, url: this.get("url"), error: errorThrown};
        that.error(err, promise, responseObserver);
      });
      
      return promise;
    }    
  });
  
  
  return AjaxChannel;
});

